
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1333Dialog extends Serenity.EntityDialog<Report_1333Row, any> {
        protected getFormKey() { return Report_1333Form.formKey; }
        protected getIdProperty() { return Report_1333Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1333Row.localTextPrefix; }
        protected getNameProperty() { return Report_1333Row.nameProperty; }
        protected getService() { return Report_1333Service.baseUrl; }
        protected getDeletePermission() { return Report_1333Row.deletePermission; }
        protected getInsertPermission() { return Report_1333Row.insertPermission; }
        protected getUpdatePermission() { return Report_1333Row.updatePermission; }

        protected form = new Report_1333Form(this.idPrefix);

    }
}